// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactSpring from "react-spring";
import * as ReactDialog from "@radix-ui/react-dialog";

var overlayRoot = CssJs.merge([CssJs.style([
            CssJs.background(CssJs.rgba(0, 0, 0, {
                      NAME: "num",
                      VAL: 0.55
                    })),
            CssJs.position("fixed"),
            CssJs.zIndex(100),
            CssJs.top(CssJs.zero),
            CssJs.left(CssJs.zero),
            CssJs.right(CssJs.zero),
            CssJs.bottom(CssJs.zero),
            CssJs.overflowY(CssJs.auto)
          ])]);

var contentRoot = CssJs.merge([
      "bg-bg0",
      CssJs.style([
            CssJs.position(CssJs.fixed),
            CssJs.zIndex(100),
            CssJs.left(CssJs.pct(50)),
            CssJs.top(CssJs.pct(50)),
            CssJs.transform(CssJs.translate(CssJs.pct(-50), CssJs.pct(-50))),
            CssJs.minWidth(CssJs.px(300)),
            CssJs.borderRadius(CssJs.px(4)),
            CssJs.maxHeight(CssJs.pct(100)),
            CssJs.overflowY(CssJs.auto)
          ])
    ]);

var Styles = {
  overlayRoot: overlayRoot,
  contentRoot: contentRoot
};

function Modal(Props) {
  var modalOpen = Props.modalOpen;
  var setModalOpen = Props.setModalOpen;
  var children = Props.children;
  var transitions = ReactSpring.useTransition(modalOpen, {
        from: {
          opacity: 0
        },
        enter: {
          opacity: 1
        },
        leave: {
          opacity: 0
        }
      });
  return React.createElement(ReactDialog.Root, {
              children: React.createElement(ReactDialog.Portal, {
                    children: Curry._1(transitions, (function (styles, item) {
                            if (item) {
                              return React.createElement(React.Fragment, undefined, React.createElement(ReactDialog.Overlay, {
                                              onClick: (function (param) {
                                                  return Curry._1(setModalOpen, (function (param) {
                                                                return false;
                                                              }));
                                                }),
                                              forceMount: true,
                                              children: React.createElement(ReactSpring.animated.div, {
                                                    className: overlayRoot,
                                                    style: styles
                                                  })
                                            }), React.createElement(ReactDialog.Content, {
                                              forceMount: true,
                                              children: React.createElement(ReactSpring.animated.div, {
                                                    className: contentRoot,
                                                    style: styles,
                                                    children: children
                                                  })
                                            }));
                            } else {
                              return null;
                            }
                          }))
                  }),
              open: modalOpen,
              onOpenChange: (function (param) {
                  return Curry._1(setModalOpen, (function (param) {
                                return true;
                              }));
                })
            });
}

var make = Modal;

export {
  Styles ,
  make ,
  
}
/* overlayRoot Not a pure module */
